import { Primitive } from '../../../types/blocks/Primitive';

const SoundBlock: Primitive = {
  name: 'SoundBlock',
  friendlyName: 'Sound',
  isInput: false,
  isPrimitive: true,
  isAvailableInEditor: true,
  tags: ['Media'],
  properties: {
    sound: {
      type: 'Audio',
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
    },
  },
  publishes: {
    // @ts-expect-error ts-migrate(2741) FIXME: Property 'action' is missing in type '{ type: "Eve... Remove this comment to see the full error message
    click: {
      type: 'Event',
    },
  },
};

export default SoundBlock;
